import type { EventSummary as GQLItem } from '../../../generated/internal.graphql';

/**
 * The event an internal (cross-account) order belongs to.
 *
 * Deliberately thin: the internal schema's `EventSummary` exposes only `id`, `name`, `startTime`
 * and `timezone`, and of those only the ones the staff screens render are mapped. `timezone` is
 * here because the staff order list can show each order's timestamps in its event's zone; it is
 * nullable, so callers must fall back. Ask the backend before assuming a field is available.
 */
export type Event = {
  id: number;
  name?: string;
  timezone?: string;
};

export const fromGql = (item: GQLItem): Event => ({
  id: item.id,
  name: item.name ?? undefined,
  timezone: item.timezone ?? undefined,
});
